export const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
export function uniqueKey(len: number, prefix = '') {
	let result = '';

	const charactersLength = CHARS.length;
	for (let i = 0; i < len; i++) {
		result += CHARS.charAt(Math.floor(Math.random() * charactersLength));
	}
	return `${prefix}_${result}`;
}

export function safeSummaryNumber(...inputs: Array<unknown>): number {
	let sum: string | number = 0;
	for (const i of inputs) {
		if (i && !Number.isNaN(i)) {
			sum += Number(i);
		}
	}
	if (!sum || Number.isNaN(sum)) {
		sum = 0;
	}
	return sum;
}

export function isEmptyString(data: string): boolean {
	return typeof data === 'string' && data.trim().length == 0;
} 